export const PRODUCTS_STORE_KEY = 'products';
export const PRODUCT_VARIANTS_STORE_KEY = 'productVariants';
